<clr-input-container>
  <label>Name</label>
  <input clrInput name="name" [(ngModel)]="flowDescription.name" />
</clr-input-container>

<clr-textarea-container>
  <label>Comment</label>
  <textarea style="width: 100%;" clrTextarea [(ngModel)]="flowDescription.comment" name="comment" required></textarea>
</clr-textarea-container>

<clr-checkbox-container>
  <clr-checkbox-wrapper>
    <input type="checkbox" clrCheckbox value="authorized" name="authorized" [(ngModel)]="flowDescription.authorized" />
    <label>Authorized</label>
  </clr-checkbox-wrapper>
</clr-checkbox-container>

<clr-select-container>
  <label>Risk</label>
  <select clrSelect name="risk" [(ngModel)]="flowDescription.risk">
    <option value="critical">Critical</option>
    <option value="medium">Medium</option>
    <option value="low">Low</option>
  </select>
</clr-select-container>

<h4>Data classification</h4>

<div style="margin-bottom: 10px;">
  @for (dataClassification of flowDescription.dataClassifications; track dataClassification) {
    <span class="label label-blue">
      {{ dataClassification }}
      <a href="javascript://" role="button" aria-label="Delete this data classification"
         (click)="deleteDataClassification(dataClassification)">
        <cds-icon shape="times-circle"></cds-icon>
      </a>
    </span>
  }

  @if (flowDescription.dataClassifications.length == 0) {
    <span class="p6">No data classification</span>
  }
</div>

<div class="clr-row">
  <div class="clr-col-8">
    <clr-input-container style="margin-top: 0px;">
      <label class="clr-sr-only">Data classification</label>
      <input clrInput name="newDataClassification" list="dataClassificationsSuggestions"
             placeholder="Operational, Security events, ..."
             [(ngModel)]="newDataClassification"
             (keyup.enter)="addDataClassification()" />
    </clr-input-container>
    <datalist id="dataClassificationsSuggestions">
      @for (suggestedDataClassification of suggestedDataClassifications; track suggestedDataClassification) {
        <option [value]="suggestedDataClassification"></option>
      }
    </datalist>
  </div>
  <div class="clr-col-4">
    <button (click)="addDataClassification()" class="btn btn-sm">
      Add data classification
    </button>
  </div>
</div>

<p class="p6" style="margin-top: 20px;">
  The network rules of this description (source, destination, protocol, port, direction) are edited by expanding
  its row in the flows descriptions datagrid.
</p>
